export default "__VITE_PUBLIC_ASSET__ee040788__"